module.exports = ".main-content {\n  margin-top: 85px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/layouts/layouts.component.scss
// module id = ./src/app/components/layouts/layouts.component.scss
// module chunks = main